/**
 * Feature Tabs
 * A simple, reliable tabs implementation that works with the CSS transitions
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all tab sections on the page
  const tabSections = document.querySelectorAll('.feature-tabs');
  
  tabSections.forEach(function(section) {
    // Get all tabs and panels in this section
    const tabs = section.querySelectorAll('.feature-tabs__tab');
    const panels = section.querySelectorAll('.feature-tabs__panel');
    
    // Set up tab click events
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        // Skip if this tab is already active
        if (tab.getAttribute('aria-selected') === 'true') {
          return;
        }
        
        // Get the target panel ID
        const panelId = tab.getAttribute('aria-controls');
        if (!panelId) return;
        
        // Find the target panel
        const targetPanel = document.getElementById(panelId);
        if (!targetPanel) return;
        
        // Deactivate all tabs and hide all panels
        tabs.forEach(function(t) {
          t.setAttribute('aria-selected', 'false');
          t.classList.remove('active');
        });
        
        panels.forEach(function(p) {
          p.setAttribute('aria-hidden', 'true');
          p.classList.remove('active');
        });
        
        // Activate the clicked tab and show its panel
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        
        targetPanel.setAttribute('aria-hidden', 'false');
        targetPanel.classList.add('active');
        
        // Format any performance metrics in the newly shown panel
        formatPerformanceMetrics(targetPanel);
      });
      
      // Add keyboard support
      tab.addEventListener('keydown', function(e) {
        // Get all tabs as an array for easier navigation
        const tabArray = Array.from(tabs);
        const currentIndex = tabArray.indexOf(tab);
        let nextIndex;
        
        switch(e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % tabArray.length;
            e.preventDefault();
            tabArray[nextIndex].focus();
            tabArray[nextIndex].click();
            break;
            
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + tabArray.length) % tabArray.length;
            e.preventDefault();
            tabArray[nextIndex].focus();
            tabArray[nextIndex].click();
            break;
            
          case 'Home':
            e.preventDefault();
            tabArray[0].focus();
            tabArray[0].click();
            break;
            
          case 'End':
            e.preventDefault();
            tabArray[tabArray.length - 1].focus();
            tabArray[tabArray.length - 1].click();
            break;
            
          case 'Enter':
          case ' ':
            e.preventDefault();
            tab.click();
            break;
        }
      });
    });
    
    // Format performance metrics in all panels
    panels.forEach(function(panel) {
      formatPerformanceMetrics(panel);
    });
  });
  
  /**
   * Formats numbers in performance metrics
   */
  function formatPerformanceMetrics(container) {
    const metrics = container.querySelectorAll('[data-performance-metric="true"]');
    
    metrics.forEach(function(metric) {
      const text = metric.textContent.trim();
      
      // Skip if already formatted (contains span)
      if (metric.querySelector('.highlight-number')) return;
      
      // Format different performance metric patterns
      let formattedText = text;
      
      // Ensure consistent arrow spacing
      formattedText = formattedText.replace(/\s*→\s*/, ' → ');
      
      // Case 1: Text with % followed by colon (1% Low FPS: 123 → 456)
      if (formattedText.includes('%') && formattedText.includes(':')) {
        const parts = formattedText.split(':');
        // Don't highlight the % part
        const beforeColon = parts[0] + ':';
        const afterColon = parts.slice(1).join(':');
        
        formattedText = beforeColon + afterColon.replace(/(\d+\.?\d*)/g, '<span class="highlight-number">$1</span>');
      }
      // Case 2: Text with % but no colon (0.2% Low FPS: 22.7 → 162.4)
      else if (formattedText.includes('%')) {
        const parts = formattedText.split('%');
        const beforePercent = parts[0] + '%';
        const afterPercent = parts.slice(1).join('%');
        
        formattedText = beforePercent + afterPercent.replace(/(\d+\.?\d*)/g, '<span class="highlight-number">$1</span>');
      }
      // Case 3: Simple metrics
      else if (formattedText.includes('→')) {
        formattedText = formattedText.replace(/(\d+\.?\d*)/g, '<span class="highlight-number">$1</span>');
      }
      
      // Clean up any comma issues
      formattedText = formattedText.replace(/(<\/span>),/g, '</span>,');
      
      metric.innerHTML = formattedText;
    });
  }
}); 